export default "__VITE_ASSET__CFDOJh66__"